import React, { useState, useEffect } from "react";
import CONSTANT from "../../const";
import { inputFormat, inputFormatToInt, moneyFormat } from "../../ultil";
import moment from "moment";
import { style, modalStyle, modalStyleCenter, modalStyleBottom } from "../../style";
import toastr from "toastr";
import _ from "lodash";
import Modal from "react-modal";
import TextTitle from "../Text/TextTitle";
import TextTitle1 from "../Text/TextTitle1";
import TextBody from "../Text/TextBody";
import TextBody2 from "../Text/TextBody2";
import TextHead from "../Text/TextHead";
import TextPrice from "../Text/TextPrice";
import TextPriceOld from "../Text/TextPriceOld";
import TextQuantity from "../Text/TextQuantity";
import TextOutOfStock from "../Text/TextOutOfStock";
import InputCustom from "../Input/InputCustom";

import {
  AppBar,
  Box,
  Divider,
  Paper,
  Tab,
  Tabs,
  Typography,
  IconButton,
  Grid,
  Button,
  ButtonBase,
  ButtonGroup,
  Toolbar,
  Slide,
  TextField,
  FormGroup,
  FormControlLabel,
  Checkbox,
  RadioGroup,
  Radio
} from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export default function TipShipperOrder({tip, setTip }) {
  const [tipView, setTipView] = useState("0đ");
  const [price, setPrice] = useState("")
  const [id, setId] = useState(0)
  const [idPrice, setIdPrice] = useState(0)
  const [openModal, setOpenModal] = useState(false);
  const handleChangeTip = (e) => {
    let value = e.target.value;
    if (inputFormatToInt(value) > 100000) {
      value = "100,000 đ";
    }
    setTipView(inputFormat(value));
  };

  const onChooseTip = (value) => {
    setIdPrice(value.id)
    if(value.id == 0){
      setTipView("0đ")
    }else{
      setTipView(value.price)
    }
  };
  const openTipModal = () => {
    setOpenModal(true);
  };
  const closeModal = () => {
    setIdPrice(id)
    setOpenModal(false);
  };
  const btnSubmit = () => {
    if (tipView) {
      setTip(inputFormatToInt(tipView));
    } else {
      setTip(0);
    }
    setOpenModal(false);
  };
  const money = [
    {
      price:"Không",
      id:0
    },
    {
      price:"5,000 đ",
      id:1
    },
    {
      price:"10,000 đ",
      id:2
    },
    {
      price:"15,000 đ",
      id:3
    },
    {
      price:"20,000 đ",
      id:4
    },
    {
      price:"25,000 đ",
      id:5
    },
    {
      price:"30,000 đ",
      id:6
    },
    {
      price:"50,000 đ",
      id:7
    },
    {
      price:"100,000 đ",
      id:8
    },
  ]

  return (
    <>
    <Box onClick={() => openTipModal()} sx={{display: 'flex', width: '100%', cursor: 'pointer'}}>
      <TextBody2 className="line-clamp-1" sx={{flexGrow: 1}}><img
        style={{ width: "30px", paddingRight: "5px" }}
        src="https://media.heyu.asia/uploads/new-img-service/2021-07-15-tip.png"
      ></img>
      Tip tài xế</TextBody2>
      {tip ? <TextBody2 color="#1589D8">{moneyFormat(tip)}</TextBody2> : null}
      <TextBody2 sx={{textAlign: 'right'}}>
      <IconButton sx={{padding: '0px'}}>
        <ArrowForwardIosIcon/>
      </IconButton>
      </TextBody2>
    </Box>
      <Modal
        isOpen={openModal}
        style={modalStyleBottom}
        onRequestClose={closeModal}
        ariaHideApp={false}
        className="animated slideInUp"

      >
      <Box sx={style}>
        <Box sx={{position: 'relative', marginBottom: '68px'}}>
          <AppBar
            position="sticky"
            color="inherit"
          >
            <Toolbar sx={{minHeight: '52px'}}>
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="menu"
                onClick={closeModal}
              >
                <ArrowBackIcon fontSize="large"/>
              </IconButton>
              <TextTitle1 sx={{flexGrow: 1}} variant="h5" component="div">
                Hỗ trợ tài xế
              </TextTitle1>
            </Toolbar>
            <Box mx={2} mb={2}>
              <InputCustom
                onSubmit={btnSubmit}
                icon={<img
                  alt="image"
                  className="img-circle"
                  width="25px"
                  src="https://media.heyu.asia/uploads/new-img-service/2021-07-15-tip.png"
                />}
                sx={{px: 2, bgcolor: '#F5F6FA', width: '100%', boxShadow: 'none', borderRadius: '16px', display: 'flex', alignItems:'center'}}
                placeholder="Nhập giá trị khác"
                value={tipView}
                onChange={(e) => handleChangeTip(e)}
              />
            </Box>
          </AppBar>
          <Grid container spacing={1} p={2} bgcolor="#ffffff">
          {money.map((item, index) => {
            return (<Grid key={index} onClick={() => onChooseTip(item)} item xs={4}>
            <div
              style={{
                border: "1px solid #0473CD",
                marginBottom: "10px",
                borderRadius: "8px",
                backgroundColor: idPrice == item.id ? "#0473CD" : "#ffffff",
              }}
            >
              <p
                style={{
                    margin: "6px",
                    fontWeight: "bold",
                    fontSize: "14px",
                    color: idPrice == item.id ? "#ffffff" : "#0473CD",
                    textAlign: 'center'
                  }}
              >
                {item.price}
              </p>
            </div>
            </Grid>
            );
          })}

          </Grid>

          <Box sx={{position: 'fixed', width: '100%', maxWidth: '600px', bottom: 0, zIndex: 1, bgcolor: '#ffffff', boxShadow: '0px -2px 8px rgba(92, 83, 83, 0.08)'}}>
            <Box sx={{width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '12px 16px'}}>
            <Button onClick={btnSubmit} fullWidth size="large" variant="contained" sx={{borderRadius: '16px', fontSize: '16px', textTransform: 'none', bgcolor: '#1589D8'}}>
              Xác nhận
            </Button>
            </Box>
          </Box>
        </Box>
      </Box>
      </Modal>
    </>
  );
}
